import { HttpClient } from '@angular/common/http';
import { Injectable }          from '@angular/core';
import { environment } from '@omnienv/omnicms/devcms/environment';
import { ApiResult } from '@omnilnp/models/api-result.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PostalService {

    constructor(
        private httpClient: HttpClient
    ) {}

    checkPostal(zip: string, number: string): Observable<ApiResult<object>> {
        return this.httpClient.get<ApiResult<object>>(environment.apiurl + "lib/postal-check/" + zip + "/" + number);
    }
}